<template>
  <div>
    <b-row class="mb-2">
      <b-col
          v-for="(file, index) in previewImages"
          :key="index"
          sm="2"
          md="2"
          class="mb-2"
      >
        <b-img v-bind="picsProps" :src="file" class="card"/>
        <button type="button" class="btn btn-danger btn-sm text-center rounded-pill mt-1 ">
          <span @click="removeImage(index)" class="badge rounded-pill"
          >حذف عکس</span
          ></button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "MultipleImagesPreview",
  props: ["preview"],
  data() {
    return {
      previewImages: this.preview,
      picsProps: {
        blankColor: "#fff",
        width: 75,
        height: 75,
        class: "m1",
      },
    };
  },
  methods: {
    removeImage(index) {
      if (confirm("آیا از حذف عکس اطمینان دارید؟")) {
        if (this.$route.params.slug !== undefined) {
          this.$store.dispatch("Product/deleteImage", index).then((e) => {
            this.preview.splice(index, 1);
          });
        } else {
          this.preview.splice(index, 1);
        }
      }
    },
  },
};
</script>